import { MapPin, Phone } from 'lucide-react';
import { cn } from './listingCardUtils.js';

export default function ListingCardMeta({ listing, show = {}, variant = 'content' }) {
  if (variant === 'row') {
    const items = [
      show.category && listing.category ? listing.category : null,
      listing.city || null,
    ].filter(Boolean);

    if (items.length === 0) return null;

    return (
      <p className="truncate text-xs text-slate-500">
        {items.join(' | ')}
      </p>
    );
  }

  if (variant === 'content' || variant === 'directory') {
    const items = [
      show.address && listing.address ? ['Location', listing.address, MapPin] : null,
      variant === 'directory' && show.phone && listing.phone ? ['Phone', listing.phone, Phone] : null,
    ].filter(Boolean);

    if (items.length === 0) return null;

    return (
      <div className="grid gap-1 text-sm text-slate-500">
        {items.map(([label, value, Icon]) => (
          <p key={label} className="flex min-w-0 items-center gap-1.5">
            <Icon aria-hidden="true" className="h-3.5 w-3.5 shrink-0" />
            <span className="truncate">{value}</span>
          </p>
        ))}
      </div>
    );
  }

  const items = [
    show.address && listing.address ? ['Address', listing.address] : null,
    show.phone && listing.phone ? ['Phone', listing.phone] : null,
    show.website && listing.website ? ['Website', listing.website] : null,
    show.hours && listing.hours ? ['Hours', listing.hours] : null,
  ].filter(Boolean);

  if (items.length === 0) return null;

  return (
    <dl className={cn('grid gap-1.5 text-sm', variant === 'hero' ? 'text-white/80' : 'text-slate-600')}>
      {items.map(([label, value]) => (
        <div key={label} className="flex min-w-0 gap-2">
          <dt className="shrink-0 font-medium">{label}:</dt>
          <dd className="truncate">{value}</dd>
        </div>
      ))}
    </dl>
  );
}
